var React = require('react');

function A2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"A2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},React.createElement("polygon",{"points":"65.95 79.65 0 84.89 26.45 0 65.95 79.65","fill":"#f47643","style":{"mixBlendMode":"multiply"}}))]);
}

A2.defaultProps = {"viewBox":"0 0 65.95 84.89"};

module.exports = A2;

A2.default = A2;
